import PropTypes from 'prop-types';
import styled from 'styled-components';
import { buildStyledComponent } from 'decisiv-ui-utils';

/* istanbul ignore next */
const styles = props => `
  color: ${props.theme.colors.base.chrome500};
  font-style: italic;
  font-weight: 200;
`;

const themePropTypes = {
  colors: PropTypes.shape({
    base: PropTypes.shape({
      chrome500: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default buildStyledComponent(
  'EmptyValue',
  styled.span,
  styles,
  { themePropTypes },
);



// WEBPACK FOOTER //
// ./elements/EmptyValue/index.js